import { useCallback, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { StopOutlined } from "@ant-design/icons";
import Modal from "../../../../components/generic/Modal";
import httpClient from "../../../../api/httpClient";
import { useDispatch } from "react-redux";
import { updateHasPremiumAccess } from "../../../../store/user/slice";
import { useSearchParams } from "react-router-dom";
const { TextArea } = Input;

const CancelPlanModal = () => {
  const [searchParams] = useSearchParams();
  const tenant_id = searchParams.get("tenant_id");
  const [showModal, setShowModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const handleSubmit = useCallback(async (values) => {
    try {
      setSubmitting(true);

      //@ts-ignore
      const { success } = await httpClient.delete(
        "paddle/subscriptions/current",
        {
          data: { ...values },
        },
      );

      if (success) {
        message.success("Cancel reason submitted");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  }, []);

  return (
    <>
      <Button
        icon={<StopOutlined />}
        type="primary"
        danger
        onClick={() => setShowModal(true)}
      >
        Cancel Plan
      </Button>

      <Modal
        open={showModal}
        title="Cancel Subscription"
        onCancel={() => setShowModal(false)}
        okButtonProps={{
          danger: true,
          disabled: submitting,
          loading: submitting,
        }}
        okText="Submit & Cancel"
        onOk={() => form.submit()}
        isProcessing={submitting}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          disabled={submitting}
        >
          <Form.Item
            label="Reason for cancellation"
            name="cancellation_reason"
            rules={[
              {
                required: true,
                message: "Please enter cancellation reason",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Tell us why you want to cancel your plan"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CancelPlanModal;
